import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AddUpdateUser from "../../AddUpdateUser/AddUpdateUser";
import SearchUserform from "../../SearchUser/SearchUserform";
import useStyles from '../../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from "@material-ui/core/Tooltip";
import SettingsIcon from "@mui/icons-material/Settings";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { API_BASE_URL, token, userLevel, adminId, userLevelAccess } from '../../../../../constants';


// const NotConnected = () => {
//     const history = useHistory();
//     const [openSidebar, setOpenSidebar] = useState(false);
//     const [filterText, setFilterText] = useState("");
//     const [data, setData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [perPage, setPerPage] = useState(50);
//     const [page, setPage] = useState(0);
//     const [search, setSearch] = useState('');
//     const [totalCount, setTotalCount] = useState(0);
//     const currentDate = new Date();
//     const sevenDaysAgo = new Date(currentDate);
//     sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
//     const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
//     const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
//     const [enquirySource, setEnquirySource] = useState([]);
//     const [selectedState, setSelectedState] = useState();
//     const [stateOptions, setStateOptions] = useState([]);
//     const [selectedBrand, setSelectedBrand] = useState();
//     const [brandOptions, setBrandOptions] = useState([]);
//     const [selectedExecutiveId, setSelectedExecutiveId] = useState(null);
//     const [executiveOptions, setExecutiveOptions] = useState([]);
//     const [sources, setSources] = useState([]);
//     const [selectedSource, setSelectedSource] = useState();
//     const [snackbarOpen, setSnackbarOpen] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState('');

//     // @@@@@@@@@@@@@@@@@@@@@@@@@ start 
//     const [productBrand, setProductBrand] = useState([]);
//     const [states, setStates] = useState([]);
//     const [selectedExecutive, setSelectedExecutive] = useState(null);
//     const [excutiveassign, setExcutiveAssign] = useState('');
//     const [selectedRows, setSelectedRows] = useState([]);
//     const [editedRows, setEditedRows] = useState({});
//     const [doubleClickedRow, setDoubleClickedRow] = useState(null);
//     const [message, setMessage] = useState('');
//     const [showMoveEnquiry, setShowMoveEnquiry] = useState(false);
//     const [moveType, setMoveType] = useState("");
//     const [isVerified, setIsVerified] = useState("");
//     const [openConfirmModal, setOpenConfirmModal] = useState(false);
//     const [campaignOptions, setCampaignOptions] = useState([]);
//     const [selectedCampaign, setSelectedCampaign] = useState([]);
//     const [selectedModel, setSelectedModel] = useState(null);
//     const [modelOptions, setModelOptions] = useState([]);
//     const [selectedProject, setSelectedProject] = useState(null);
//     const [projectOptions, setProjectOptions] = useState([]);
//     const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//     const [isDataLoaded, setIsDataLoaded] = useState(false);
//     const [selectedLeadSource, setSelectedLeadSource] = useState("");
//     const [changeBrand, setChangeBrand] = useState(false);
//     const [changeBrandId, setChangeBrandId] = useState(null);


//     const showLeadSource =
//         moveType === "1" &&
//         [12, 16, 17].includes(Number(selectedBrand?.id));
//     const sourceCodeOptions = [
//         { id: "CC0117P", title: "KG Paid" },
//         { id: "CC0117O", title: "KG Organic" },
//         { id: "CC0117B", title: "KG Branding" },
//     ];

//     const exportSelectedRowsToCSV = () => {
//         const selectedData = selectedRows.map((index) => {
//             const row = {
//                 ...data[index],
//                 ...(editedRows[index] || {}),
//             };
//             return {
//                 "Date": row?.created_at ?? "",
//                 "Brand Name": row?.brand_name ?? "",
//                 "Model Name": row.tractor_model_name || selectedModel?.title || "",
//                 "First Name": row?.first_name ?? "",
//                 "Last Name": row?.last_name ?? "",
//                 "Mobile": row?.mobile ?? "",
//                 "Email": row?.email ?? "",
//                 "State": row?.state_name ?? "",
//                 "City": row?.city_name ?? "",
//                 "Taluka": row?.taluka ?? "",
//                 "Enquiry Type": row?.enquiry_name ?? "",
//                 "Enquiry Source": row?.enquiry_from ?? "",
//                 "Executive": row?.executive ?? "",
//             };
//         });
//         if (selectedData.length === 0) {
//             setSnackbarMessage("Please select at least one row");
//             setSnackbarOpen(true);
//             return;
//         }
//         const headers = Object.keys(selectedData[0]);
//         const csvRows = [
//             headers.join(","),
//             ...selectedData.map(row =>
//                 headers.map(header => `"${row[header] ?? ""}"`).join(",")
//             )
//         ];
//         const csvContent = csvRows.join("\n");
//         const blob = new Blob([csvContent], {
//             type: "text/csv;charset=utf-8;"
//         });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.setAttribute(
//             "download",
//             `SocialCampaigns_${new Date().toISOString().split("T")[0]}.csv`
//         );
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };
//     const handleCellChange = (rowIndex, field, value) => {
//         setEditedRows((prev) => ({
//             ...prev,
//             [rowIndex]: {
//                 ...data[rowIndex],
//                 ...(prev[rowIndex] || {}),
//                 [field]: value,
//             },
//         }));
//     };
//     const handleConfirmSubmit = async () => {
//         if (!validateMoveEnquiryForm()) {
//             return;
//         }
//         await handleMoveEnquirySubmit();
//     };
//     useEffect(() => {
//         fetchCampaignList();
//     }, []);
//     const fetchCampaignList = async () => {
//         try {
//             const config = {
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Accept": "application/json",
//                     "Authorization": token,
//                 }
//             };
//             const response = await axios.post(
//                 `${API_BASE_URL}/api/admin/v2/campaign-list`,
//                 {},
//                 config
//             );
//             const campaigns =
//                 response?.data?.data?.assigned_list?.map(item => ({
//                     id: item.id,
//                     title: item.campaign_id
//                 })) || [];
//             setCampaignOptions(campaigns);
//         } catch (error) {
//             console.log(error);
//         }
//     };
//     useEffect(() => {
//         fetchProjectList();
//     }, []);
//     const fetchProjectList = async () => {
//         try {
//             const config = {
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Accept": "application/json",
//                     "Authorization": token,
//                 },
//             };
//             const response = await axios.post(
//                 `${API_BASE_URL}/api/admin/v2/assign-project-brand-list`,
//                 {},
//                 config
//             );
//             const projects =
//                 response?.data?.data?.data?.map(item => ({
//                     id: item.id,
//                     title: item.project_name,
//                     brand_id: item.brand_id,
//                     brand_name: item.brand_name,
//                 })) || [];
//             setProjectOptions(projects);
//         } catch (error) {
//             console.error(error);
//         }
//     };
//     const handleBrandChange = async (event, newValue) => {
//         setSelectedBrand(newValue);
//         setSelectedModel(null);
//         setModelOptions([]);
//         if (!newValue?.id) return;
//         try {
//             const config = {
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Accept": "application/json",
//                     "Authorization": token,
//                 },
//             };
//             const response = await axios.post(
//                 `${API_BASE_URL}/api/admin/v2/brand-model-list`,
//                 {
//                     brand_id: newValue.id
//                 },
//                 config
//             );
//             const models =
//                 response?.data?.data?.map(item => ({
//                     id: item.tractor_model_id,
//                     title: item.tractor_model_name
//                 })) || [];

//             setModelOptions(models);
//         } catch (error) {
//             console.error(error);
//         }
//     };
//     const handleProjectChange = (event, newValue) => {
//         setSelectedProject(newValue);
//     };
//     const validateMoveEnquiryForm = () => {
//         if (!isDataLoaded) {
//             setSnackbarSeverity("error");
//             setSnackbarMessage("Please click 'Get Data' before moving enquiries.");
//             setSnackbarOpen(true);
//             return false;
//         }
//         if (data.length === 0) {
//             setSnackbarSeverity("error");
//             setSnackbarMessage("No data found. Please click Get Data.");
//             setSnackbarOpen(true);
//             return false;
//         }
//         if (!selectedBrand?.id) {
//             setSnackbarSeverity("error");
//             setSnackbarMessage("Brand is required");
//             setSnackbarOpen(true);
//             return false;
//         }
//         if (!isVerified) {
//             setSnackbarSeverity("error");
//             setSnackbarMessage("Lead Type is required");
//             setSnackbarOpen(true);
//             return false;
//         }
//         if (!moveType) {
//             setSnackbarSeverity("error");
//             setSnackbarMessage("Move Type is required");
//             setSnackbarOpen(true);
//             return false;
//         }
//         if (selectedRows.length === 0) {
//             setSnackbarSeverity("error");
//             setSnackbarMessage("Please select at least one enquiry");
//             setSnackbarOpen(true);
//             return false;
//         }
//         return true;
//     };
//     const handleMoveEnquiryClick = () => {
//         if (!validateMoveEnquiryForm()) {
//             return;
//         }
//         setOpenConfirmModal(true);
//     };
//     const handleResetFields = () => {
//         setSnackbarSeverity("success");
//         setSelectedBrand(null);
//         setSelectedModel(null);
//         setSelectedState(null);
//         setSelectedProject(null);
//         setChangeBrand(false);
//         setChangeBrandId(null);
//         setIsVerified("");
//         setMoveType("");
//         setFromDate(currentDate.toISOString().split("T")[0]);
//         setToDate(currentDate.toISOString().split("T")[0]);
//         setSelectedRows([]);
//         setSelectedExecutive("");
//         setSelectedLeadSource("");
//         setSnackbarOpen(true);
//         setOpenConfirmModal(false);
//         setSnackbarMessage("Form fields reset successfully");
//     };

//     // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@ end

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await axios.get(`${API_BASE_URL}/webApi/sources`);
//                 const data = response.data.data;
//                 setSources(data.map(item => item.enquiry_from));
//             } catch (error) {
//                 console.error('Error fetching data:', error);
//             }
//         };
//         fetchData();
//     }, []);

//     const handleSelectChange = (event) => {
//         setSelectedSource(event.target.value);
//     };

//     useEffect(() => {
//         const fetchDatabrand = async () => {
//             try {
//                 const config = {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Accept': 'application/json',
//                         'Authorization': `${token}`,
//                     },
//                     timeout: Infinity,
//                 };
//                 const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
//                 const statelist = response.data.data.map(item => ({
//                     id: item.brand_id,
//                     title: item.brand_name,
//                 }));
//                 setBrandOptions(statelist);
//             } catch (error) {
//                 console.error('Error fetching state:', error);
//             }
//         };
//         fetchDatabrand();
//     }, []);

//     useEffect(() => {
//         const fetchDatastate = async () => {
//             try {
//                 const config = {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Accept': 'application/json',
//                         'Authorization': `${token}`,
//                     },
//                     timeout: Infinity,
//                 };
//                 const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
//                 const statelist = response.data.data.map(item => ({
//                     id: item.state_id,
//                     title: item.state_name,
//                 }));
//                 setStateOptions(statelist);
//             } catch (error) {
//                 console.error('Error fetching state:', error);
//             }
//         };
//         fetchDatastate();
//     }, []);

//     useEffect(() => {
//         const fetchDatalist = async () => {
//             try {
//                 const config = {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Accept': 'application/json',
//                         'Authorization': `${token}`,
//                     },
//                     timeout: Infinity,
//                 };

//                 const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
//                 const mappedData = response.data.data.map(item => ({
//                     id: item.admin_id,
//                     title: item.username,
//                 }));
//                 setExecutiveOptions(mappedData);
//             } catch (error) {
//                 console.error('Error fetching executives:', error);
//             }
//         };
//         fetchDatalist();
//     }, []);

//     const handleExecutiveChange = (event) => {
//         const selectedId = event.target.value;
//         setSelectedExecutiveId(selectedId);
//     };
//     const handleStateChange = (event, newValue) => {
//         setSelectedState(newValue);
//     };

//     // const handleBrandChange = (event, newValue) => {
//     //     setSelectedBrand(newValue);
//     // };

//     const fetchData = async (from, to, pageNumber, searchQuery,) => {
//         setIsLoading(true);
//         setError(null);
//         try {
//             const config = {
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Accept': 'application/json',
//                     'Authorization': `${token}`,
//                     'adminId': `${adminId}`,
//                     'userLevel': `${userLevel}`,
//                 },
//                 timeout: Infinity,
//             };

//             const requestData = {
//                 start_date: fromDate,
//                 end_date: toDate,
//                 pagination: perPage,
//                 page: page + 1,
//                 search: search,
//                 product_brand: selectedBrand,
//                 enquiry_source: enquirySource,
//                 states: selectedState,
//                 executive: selectedExecutiveId,
//                 user_level: userLevel,
//                 admin_id: adminId,
//                 enquiry_source: selectedSource ? [{ from: selectedSource }] : null,
//             };
//             if (userLevel === 'executive') {
//                 requestData.executive = adminId;
//             } else {
//                 requestData.executive = selectedExecutiveId;
//             }
//             const response = await axios.post(`${API_BASE_URL}/api/admin/v2/not-connected-enquiry`, requestData, config);

//             const mappedData = response.data.data.data.map(item => {
//                 const formattedDate = new Date(item.updated_at).toLocaleString('en-IN', {
//                     year: 'numeric',
//                     month: 'short',
//                     day: '2-digit',
//                     hour12: true,
//                 });
//                 const date = item.date ? new Date(item.date).toLocaleString('en-IN', {
//                     year: 'numeric',
//                     month: 'short',
//                     day: '2-digit',
//                     hour12: true,
//                 }) : "";
//                 const first_name = item.user.first_name;
//                 const last_name = item.user.last_name;
//                 const fullName = `${item.user.first_name} ${item.user.last_name}`;
//                 const tractorname = item.tractor_table.tractor_model ? item.tractor_table.tractor_model.tractor_model_name : '';
//                 const brandname = item.tractor_table.brand ? item.tractor_table.brand.brand_name : '';
//                 const stateName = item.user.state ? item.user.state.state_name : '';
//                 const cityName = item.user.city ? item.user.city.city_name : '';
//                 const taluka = item.user.taluka ? item.user.taluka.name : '';
//                 const executive = item.executive ? item.executive.username : '';
//                 const admin_id = item.executive ? item.executive.admin_id : '';
//                 const call_status = item.crm_call_status ? item.crm_call_status.call_status : '';
//                 const pincode = item.user.user_details ? item.user.user_details.pincode : '';
//                 const village = item.user.user_details ? item.user.user_details.village : '';
//                 const land = item.user.user_details ? item.user.user_details.land : '';
//                 const exchangetractor = item.exchanged_tractor ? item.exchanged_tractor.tractor_name : '';
//                 const loan_types = item.enq_details ? item.enq_details.map(detail => detail.loan_type) : [];

//                 const loanTypesObject = {};
//                 loan_types.forEach((type, index) => {
//                     loanTypesObject[`loan_type_${index + 1}`] = type;
//                 });
//                 const lastValue = loanTypesObject[`loan_type_${Object.keys(loanTypesObject).length}`];
//                 const Purchasedate = item.enq_details ? item.enq_details.map(detail => {
//                     const options = {
//                         year: 'numeric',
//                         month: 'short',
//                         day: '2-digit',
//                         hour12: true,
//                     };
//                     return new Date(detail.date).toLocaleString('en-IN', options);
//                 }) : [];
//                 return {
//                     id: item.id,
//                     enquiry_name: item.enquiry_name,
//                     fullName: fullName,
//                     mobile: item.user.mobile,
//                     email: item.user.email,
//                     created_at: formattedDate,
//                     tractor_model_name: tractorname,
//                     brand_name: brandname,
//                     state_name: stateName,
//                     city_name: cityName,
//                     taluka: taluka,
//                     executive: executive,
//                     admin_id: admin_id,
//                     enquiry_from: item.enquiry_from,
//                     is_dublicate: item.is_dublicate,
//                     call_status: call_status,
//                     pincode: pincode,
//                     village: village,
//                     land: land,
//                     loan_type: lastValue,
//                     Purchasedate: date,
//                     exchanged: item.exchanged,
//                     tractor_name: exchangetractor,
//                     first_name: first_name,
//                     last_name: last_name,
//                     enq_details_count: item.enq_details_count,
//                 };
//             });
//             setData(mappedData);
//             setTotalCount(response.data.data.total);
//             setSnackbarMessage(response.data.message);
//             setSnackbarOpen(true);
//             setIsLoading(false);
//             setIsDataLoaded(true);

//         } catch (error) {
//             console.error("Error fetching data:", error);
//             if (axios.isCancel(error)) {
//                 console.error("Request canceled:", error.message);
//             } else {
//                 if (error.code === 'ECONNABORTED') {
//                     setError('The request timed out. Please try again.');
//                 } else if (error.response) {
//                     console.error("Server Error Details:", error.response.data);
//                     setError(`Error: ${error.response.status} - ${error.response.statusText}`);
//                 } else {
//                     setError('An error occurred while fetching data.');
//                 }
//             }

//         } finally {
//             setIsLoading(false);
//         }
//     };
//     const source = axios.CancelToken.source();
//     const sourceRef = useRef(null);
//     useEffect(() => {
//         sourceRef.current = axios.CancelToken.source();
//         fetchData(
//             perPage,
//             page,
//             search,
//             totalCount,
//             selectedExecutiveId,
//             selectedBrand,
//             selectedState,
//             enquirySource,
//             sourceRef.current
//         );
//         return () => {
//             sourceRef.current.cancel('Request canceled by cleanup');
//         };
//     }, [perPage, page,], 2000);

//     const handleDateChange = (e) => {
//         const { name, value } = e.target;
//         if (name === 'fromDate') {
//             setFromDate(value);
//         } else if (name === 'toDate') {
//             setToDate(value);
//         }
//     };

//     const handlePerPageChange = (e) => {
//         setPerPage(Number(e.target.value));
//     };

//     const handlePrevious = () => {
//         if (page > 0) {
//             setPage(page - 1);
//         }
//     };

//     const handleNext = () => {
//         setPage(page + 1);
//     };

//     const handleSearchChange = (e) => {
//         setSearch(e.target.value);
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         setPage(0);
//         fetchData(perPage, page, search, totalCount, selectedExecutiveId, selectedBrand, selectedState, enquirySource);
//     };

//     const clearForm = () => {
//         window.location.reload();
//         setSearch('');
//     };
//     const handleSelectAllCheck = () => {
//         if (selectedRows.length === data.length) {
//             setSelectedRows([]);
//         } else {
//             setSelectedRows(Array.from({ length: data.length }, (_, i) => i));
//         }
//     };
//     const handleRowSelect = (rowIndex) => {
//         if (selectedRows.includes(rowIndex)) {
//             setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
//         } else {
//             setSelectedRows([...selectedRows, rowIndex]);
//         }
//     };

//     const handleSelectedRowsCount = () => {
//         return selectedRows.length;
//     };


//     const columns = [
//         {
//             name: 'id',
//             label: (
//                 <input
//                     type="checkbox"
//                     checked={selectedRows.length === data.length && data.length !== 0}
//                     onChange={handleSelectAllCheck}
//                 />
//             ),
//             options: {
//                 filter: false,
//                 sort: false,
//                 customBodyRender: (value, tableMeta) => (
//                     <input
//                         type="checkbox"
//                         checked={selectedRows.includes(tableMeta.rowIndex)}
//                         onChange={() => handleRowSelect(tableMeta.rowIndex)}
//                     />
//                 ),
//             },
//         },
//         {
//             name: 'id',
//             label: 'S/N',
//             options: {
//                 filter: true,
//                 setCellProps: () => ({
//                     align: "center",
//                 }),
//             },
//         },
//         {
//             name: 'created_at', options: {
//                 filter: true,
//                 setCellProps: () => ({
//                     align: "left",
//                 })
//             },
//             label: "Date",
//         },
//         {
//             name: "enquiry_name",
//             label: "Type",
//             options: {
//                 filter: false,
//                 customBodyRender: (value, tableMeta, updateValue) => (
//                     <button
//                         className={classes.typestrip}
//                         style={{
//                             backgroundColor: getColor(value),
//                         }}
//                     >
//                         {value}
//                     </button>
//                 ),
//             },
//         },
//         {
//             name: "brand_name",
//             label: "Brand",
//             options: {
//                 filter: false,
//                 customBodyRender: (value, tableMeta, updateValue) => (
//                     <button
//                         className={classes.brandstrip}
//                         style={{
//                             backgroundColor: getColor(value),
//                             color: getColorfont(value),
//                         }}
//                     >
//                         {value}
//                     </button>
//                 ),
//             },
//         },
//         {
//             name: "tractor_model_name",
//             label: "Model ",
//         },
//         {
//             name: "fullName",
//             label: "User ",
//         },
//         {
//             name: "mobile",
//             label: "Mobile  ",
//         },
//         {
//             name: "state_name",
//             label: "State  ",
//         },
//         {
//             name: "city_name",
//             label: "City  ",
//         },
//         {
//             name: "taluka",
//             label: "Taluka  ",
//         },
//         {
//             name: "pincode",
//             label: "Pinecode  ",
//         },
//         {
//             name: "village",
//             label: "Village  ",
//         },
//         {
//             name: "land",
//             label: "Land  ",
//         },


//         {
//             name: "enquiry_from",
//             label: "Source",
//             options: {
//                 filter: false,
//                 customBodyRender: (value, tableMeta, updateValue) => (
//                     <button
//                         className={classes.typestrip}
//                         style={{
//                             backgroundColor: getColor(value),
//                         }}
//                     >
//                         {value}
//                     </button>
//                 ),
//             },
//         },
//         {
//             name: "name",
//             label: "Status",
//         },
//         {
//             name: "executive",
//             label: "Executive ",
//         },
//         {
//             name: "enq_details_count",
//             label: "Followup",
//             options: {
//                 filter: false,
//                 customBodyRender: (value, tableMeta, updateValue) => (
//                     <button
//                         className={classes.typestrip}
//                         style={{
//                             backgroundColor: getColor(value),
//                         }}
//                     >
//                         {value}
//                     </button>
//                 ),
//             },
//         },
//         {
//             name: "Purchasedate",
//             label: "Followp Date",
//         },
//         {
//             name: "actions",
//             label: "Actions",
//             options: {
//                 filter: false,
//                 setCellProps: () => ({
//                     align: "right",
//                 }),
//                 customBodyRender: (value, tableMeta) => {
//                     const rowIndex = tableMeta.rowIndex;
//                     const rowData = data[rowIndex];
//                     return (
//                         <>
//                             <div style={{ display: "flex", margin: "auto", padding: "auto", textAlign: "center" }} >
//                                 <Link to={`/app/NotConnectedView/${tableMeta.rowData[0]}`} target="_blank">
//                                     <VisibilityIcon className={classes.tableiconedit} />
//                                 </Link>
//                             </div>
//                         </>
//                     );
//                 },
//             },
//         },
//     ];

//     const columnsEdittable = [
//         {
//             name: 'id',
//             label: (
//                 <input
//                     type="checkbox"
//                     checked={selectedRows.length === data.length && data.length !== 0}
//                     onChange={handleSelectAllCheck}
//                 />
//             ),
//             options: {
//                 filter: false,
//                 sort: false,
//                 customBodyRender: (value, tableMeta) => (
//                     <input
//                         type="checkbox"
//                         checked={selectedRows.includes(tableMeta.rowIndex)}
//                         onChange={() => handleRowSelect(tableMeta.rowIndex)}
//                     />
//                 ),
//             },
//         },
//         {
//             name: 'id', options: {
//                 filter: false,
//                 setCellProps: () => ({
//                     align: "left",
//                 })
//             },
//             label: "S/N",
//         },
//         {
//             name: 'created_at',
//             options: {
//                 filter: false,
//                 setCellProps: () => ({
//                     align: "left",
//                 })
//             },
//             label: "Date",
//         },
//         {
//             name: "enquiry_name",
//             label: "Type",
//             options: {
//                 filter: false,
//                 customBodyRender: (value, tableMeta, updateValue) => (
//                     <button
//                         className={classes.typestrip}
//                         style={{
//                             backgroundColor: getColor(value),
//                             width: "100%",

//                         }}
//                     >
//                         {value}
//                     </button>
//                 ),
//             },
//         },
//         {
//             name: "brand_name",
//             label: "Brand",
//             options: {
//                 filter: false,
//                 customBodyRender: (value, tableMeta, updateValue) => (
//                     <button
//                         className={classes.brandstrip}

//                         style={{
//                             backgroundColor: getColor(value),
//                             color: getColorfont(value),
//                             width: "100% !important",

//                         }}
//                     >
//                         {value}
//                     </button>
//                 ),
//             },
//         },
//         {
//             name: "tractor_model_name",
//             label: "Model ",
//             options: {
//                 filter: false,
//             }
//         },
//         {
//             name: "first_name",
//             label: "First Name",
//             options: {
//                 customBodyRender: (value, tableMeta) => {
//                     const rowIndex = tableMeta.rowIndex;

//                     return (
//                         <input
//                             style={inputStyle}
//                             value={editedRows[rowIndex]?.first_name ?? value ?? ""}
//                             onChange={(e) =>
//                                 handleCellChange(
//                                     rowIndex,
//                                     "first_name",
//                                     e.target.value
//                                 )
//                             }
//                         />
//                     );
//                 }
//             }
//         },
//         {
//             name: "last_name",
//             label: "Last Name",
//             options: {
//                 customBodyRender: (value, tableMeta) => {
//                     const rowIndex = tableMeta.rowIndex;

//                     return (
//                         <input
//                             style={inputStyle}
//                             value={editedRows[rowIndex]?.last_name ?? value ?? ""}
//                             onChange={(e) =>
//                                 handleCellChange(
//                                     rowIndex,
//                                     "last_name",
//                                     e.target.value
//                                 )
//                             }
//                         />
//                     );
//                 }
//             }
//         },
//         {
//             name: "mobile",
//             label: "Mobile",
//             options: {
//                 customBodyRender: (value, tableMeta) => {
//                     const rowIndex = tableMeta.rowIndex;

//                     return (
//                         <input
//                             type="text"
//                             value={
//                                 editedRows[rowIndex]?.mobile ??
//                                 value ??
//                                 ""
//                             }
//                             onChange={(e) =>
//                                 handleCellChange(
//                                     rowIndex,
//                                     "mobile",
//                                     e.target.value
//                                 )
//                             }
//                             style={inputStyle}
//                         />
//                     );
//                 }
//             }
//         },
//         {
//             name: "email",
//             label: "Email ",
//             options: {
//                 filter: false,
//             }
//         },
//         {
//             name: "state_name",
//             label: "State",
//             options: {
//                 filter: false,
//             }
//         },
//         {
//             name: "city_name",
//             label: "City ",
//             options: {
//                 filter: false,
//             }
//         },
//         {
//             name: "taluka",
//             label: "Taluka ",
//             options: {
//                 filter: false,
//             }
//         },
//         {
//             name: "enquiry_from",
//             label: "From ",
//             options: {
//                 filter: false,
//                 customBodyRender: (value, tableMeta, updateValue) => (
//                     <button
//                         className={classes.typestrip}
//                         style={{
//                             backgroundColor: getColor(value),
//                             width: "100%",

//                         }}
//                     >
//                         {value}
//                     </button>
//                 ),
//             },
//         },
//         {
//             name: "executive",
//             label: "Executive ",
//             options: {
//                 filter: false,
//             }

//         },
//         {
//             name: "is_dublicate",
//             label: "Dublicate ",
//             options: {
//                 filter: false,
//             }
//         },
//         {
//             name: "actions",
//             label: "Actions",
//             options: {
//                 filter: false,
//                 setCellProps: () => ({
//                     align: "right",
//                 }),
//                 customBodyRender: (value, tableMeta) => {
//                     const rowIndex = tableMeta.rowIndex;
//                     const rowData = data[rowIndex];
//                     return (
//                         <>
//                             <Link to={`/app/UpdateFollowUpEnquiry/${rowData.id}/crm`} target="_blank">
//                                 <Button
//                                     style={{ width: "20px", fontSize: "10px" }}
//                                     className={classes.buttonform}
//                                     variant="outlined" startIcon={<EditIcon style={{ fontSize: "12px" }} />}>
//                                     Update
//                                 </Button>
//                             </Link>
//                         </>
//                     );
//                 },
//             },
//         },
//     ];

//     const CustomToolbarAction = ({ toggleFilter }) => (
//         <IconButton aria-label="Filter list" onClick={toggleFilter}>
//             <FilterListIcon onClick={toggleSidebar} />
//         </IconButton>
//     );

//     useEffect(() => {
//         const handleKeyPress = (event) => {
//             if (event.shiftKey && event.key === 'F') {
//                 setOpenSidebar(true);
//             }
//         };
//         window.addEventListener('keydown', handleKeyPress);
//         return () => {
//             window.removeEventListener('keydown', handleKeyPress);
//         };
//     }, []);
//     const toggleSidebar = () => {
//         setOpenSidebar(!openSidebar);
//     };

//     const options = {
//         rowsPerPage: perPage,
//         selectableRows: 'none',
//         page: page,
//         serverSide: true,
//         count: totalCount,
//         onTableChange: (action, tableState) => {
//             switch (action) {
//                 case 'changePage':
//                     setPage(tableState.page);
//                     break;
//                 case 'changeRowsPerPage':
//                     setPerPage(tableState.rowsPerPage);
//                     setPage(0);
//                     break;
//                 default:
//                     break;
//             }
//         },

//         customToolbar: () => <CustomToolbarAction />,
//         filter: false,
//         filterType: "dropdown",
//         responsive: "standard",
//         fixedHeader: true,
//         fixedSelectColumn: true,
//         overflowy: "auto",
//         overflowx: "auto",
//         rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
//         customFilterDialogFooter: (currentFilter, applyNewFilter) => (
//             <div>
//                 <TextField
//                     label="Filter Data"
//                     value={filterText}
//                     onChange={(e) => setFilterText(e.target.value)}
//                     fullWidth
//                 />
//                 <Button onClick={applyNewFilter} variant="contained" color="primary">
//                     Apply Filter
//                 </Button>
//                 <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
//                     Cancel
//                 </Button>
//             </div>
//         ),

//     };
//     const currentTheme = customTheme(true);
//     const classes = useStyles();
//     const memoizedData = useMemo(() => data, [data]);
//     const handleCloseSnackbar = (event, reason) => {
//         if (reason === 'clickaway') {
//             return;
//         }
//         setSnackbarOpen(false);
//     };

//     const handleMoveEnquirySubmit = async () => {
//         if (!validateMoveEnquiryForm()) return;
//         try {
//             const config = {
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Accept": "application/json",
//                     "Authorization": `${token}`,
//                     "adminid": `${adminId}`,
//                     "userlevel": `${userLevel}`,
//                 }
//             };
//             const payload = {
//                 move_type: Number(moveType),
//                 ...(showLeadSource && { lead_source: selectedLeadSource }),
//                 brand_id: selectedBrand?.id || null,
//                 change_brand: changeBrand ? 1 : 0,
//                 change_brand_id:
//                     changeBrand && changeBrandId ? Number(changeBrandId.id) : null,
//                 state_id: selectedState?.id || null,
//                 project_id: selectedProject?.id || null,
//                 is_verified: isVerified,
//                 model: selectedModel?.title || "",
//                 id_selected: selectedRows.map(index => {
//                     const row = {
//                         ...data[index],
//                         ...(editedRows[index] || {}),
//                     };
//                     return {
//                         id: row.id,
//                         first_name: row.first_name || "",
//                         last_name: row.last_name || "",
//                         email: row.email || "",
//                         mobile: row.mobile || "",
//                         state: row.state_id || "",
//                         city: row.city_id || "",
//                         taluka: row.taluka_id || "",
//                         // modelName: row.tractor_model_name || ""
//                     };
//                 })
//             };
//             const response = await axios.post(
//                 `${API_BASE_URL}/api/admin/v2/move-to-allenquiries`,
//                 payload,
//                 config
//             );
//             if (
//                 response?.data?.status_code === 200 &&
//                 !response?.data?.error
//             ) {
//                 setSnackbarSeverity("success");
//                 setSnackbarMessage(response.data.message);
//                 setSnackbarOpen(true);
//                 setSelectedRows([]);
//                 fetchData();
//                 setOpenConfirmModal(false);
//             }

//         } catch (error) {
//             setSnackbarSeverity("error");
//             setSnackbarMessage(
//                 error?.response?.data?.message ||
//                 "Something went wrong"
//             );
//             setSnackbarOpen(true);
//         }
//     };

//     const tableColumns = useMemo(() => {
//         return ["1", "2",].includes(moveType)
//             ? columnsEdittable
//             : columns;
//     }, [moveType, editedRows, columnsEdittable, columns]);

//     useEffect(() => {
//         setSelectedRows([]);
//         setEditedRows({});
//         setIsDataLoaded(false);
//     }, [
//         selectedCampaign,
//         selectedBrand,
//         selectedModel,
//         selectedState,
//         selectedProject,
//         isVerified,
//         moveType,
//         fromDate,
//         toDate,
//         page,
//         perPage
//     ]);

//     return (
//         <>
//             <div>
//                 <Snackbar
//                     anchorOrigin={{
//                         vertical: "top",
//                         horizontal: "right"
//                     }} open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
//                     <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
//                         {snackbarMessage}
//                     </MuiAlert>
//                 </Snackbar>
//             </div>
//             <div style={{ display: "flex" }}>
//                 <Grid item xs={10} sm={6} lg={10} >
//                     <Link to="/app/allEnquiries" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheaderfirst)}> All Enquiries </Link>

//                     <Link to="/app/TodayPending" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)} >Today's Pending </Link>
//                     <Link to="/app/Interested" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)} >Interested</Link>
//                     <Link to="/app/AlreadyPurchased" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)} >Already Purchased</Link>
//                     <Button
//                         style={{ marginLeft: "20px", }}
//                         className={classes.buttonred}
//                         variant="outlined" startIcon={<LightModeIcon />}>
//                         Not Connected
//                     </Button>

//                     <Link className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)}>Update / FollowUp</Link>
//                     {userLevelAccess === "super" && (
//                         <Link className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)}
//                             onClick={() => setShowMoveEnquiry(!showMoveEnquiry)}
//                             style={{
//                                 cursor: "pointer",
//                                 color: showMoveEnquiry ? "green" : "red",
//                                 fontWeight: "bold"
//                             }}
//                         >
//                             Move to Enquiry ({showMoveEnquiry ? "ON" : "OFF"})
//                         </Link>
//                     )}

//                 </Grid>
//                 <Grid item xs={4} sm={2} lg={2} style={{ textAlign: "right", margin: "auto", padding: "auto" }}>
//                     <Grid container>
//                         <Grid item xs={10} sm={10} lg={10}>
//                             <SearchUserform />
//                         </Grid>
//                         <Grid item xs={2} sm={2} lg={2} style={{ paddingTop: "8px" }}>
//                             <AddUpdateUser />
//                         </Grid>
//                     </Grid>
//                 </Grid>
//             </div>
//             <Box sx={{ width: '100%' }}>
//                 <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
//                 </Typography>
//                 <hr className={classes.horizontalline} />
//             </Box>
//             {showMoveEnquiry && (

//                 <div className={classes.root}>
//                     <div className={classes.root}  >
//                         <Grid container spacing={1}>
//                             <Grid item xs={4} sm={2} lg={2} >
//                                 <input
//                                     type="date"
//                                     name="fromDate"
//                                     value={fromDate}
//                                     onChange={handleDateChange}
//                                     className={classes.inputform}
//                                 />
//                             </Grid>

//                             <Grid item xs={4} sm={2} lg={2}>
//                                 <input
//                                     className={classes.inputform}
//                                     type="date"
//                                     name="toDate"
//                                     value={toDate}
//                                     onChange={handleDateChange}
//                                 />
//                             </Grid>

//                             <Grid item xs={4} sm={2} lg={2} >
//                                 <Autocomplete
//                                     classes={{
//                                         option: classes.autocompleteoption,
//                                     }}
//                                     options={brandOptions}
//                                     getOptionLabel={(option) => option.title}
//                                     renderInput={(params) => (
//                                         <TextField {...params} placeholder='Select brand' variant="outlined" />
//                                     )}
//                                     value={selectedBrand}
//                                     onChange={handleBrandChange}
//                                     disableCloseOnSelect
//                                     isOptionEqualToValue={(option, value) => option.id === value.id}
//                                     getOptionSelected={(option, value) => option.id === value.id}
//                                     renderOption={(props, option, { selected }) => (
//                                         <li {...props}>
//                                             {option.title}
//                                         </li>
//                                     )}
//                                 />
//                             </Grid>

//                             <Grid item xs={4} sm={2} lg={2}>
//                                 <Autocomplete
//                                     classes={{
//                                         option: classes.autocompleteoption,
//                                     }}
//                                     options={modelOptions}
//                                     getOptionLabel={(option) => option.title || ""}
//                                     renderInput={(params) => (
//                                         <TextField
//                                             {...params}
//                                             placeholder="Select Model"
//                                             variant="outlined"
//                                         />
//                                     )}
//                                     value={selectedModel}
//                                     onChange={(event, newValue) => setSelectedModel(newValue)}
//                                     disableCloseOnSelect
//                                     isOptionEqualToValue={(option, value) => option.id === value.id}
//                                     getOptionSelected={(option, value) => option.id === value.id}
//                                     renderOption={(props, option) => (
//                                         <li {...props}>
//                                             {option.title}
//                                         </li>
//                                     )}
//                                 />
//                             </Grid>

//                             <Grid item xs={4} sm={2} lg={2} >
//                                 <Autocomplete
//                                     classes={{
//                                         option: classes.autocompleteoption,
//                                     }}
//                                     options={stateOptions}
//                                     getOptionLabel={(option) => option.title}
//                                     renderInput={(params) => (
//                                         <TextField {...params} placeholder='Select State' variant="outlined" />
//                                     )}
//                                     value={selectedState}
//                                     onChange={handleStateChange}
//                                     disableCloseOnSelect
//                                     isOptionEqualToValue={(option, value) => option.id === value.id}
//                                     getOptionSelected={(option, value) => option.id === value.id}
//                                     renderOption={(props, option, { selected }) => (
//                                         <li {...props}>
//                                             {option.title}
//                                         </li>
//                                     )}
//                                 />
//                             </Grid>
//                             <Grid item xs={4} sm={2} lg={2}>
//                                 <Autocomplete
//                                     classes={{
//                                         option: classes.autocompleteoption,
//                                     }}
//                                     options={projectOptions}
//                                     getOptionLabel={(option) => option.title || ""}
//                                     renderInput={(params) => (
//                                         <TextField
//                                             {...params}
//                                             placeholder="Select Project Name"
//                                             variant="outlined"
//                                         />
//                                     )}
//                                     value={selectedProject}
//                                     onChange={handleProjectChange}
//                                     disableCloseOnSelect
//                                     isOptionEqualToValue={(option, value) => option.id === value.id}
//                                     getOptionSelected={(option, value) => option.id === value.id}
//                                     renderOption={(props, option) => (
//                                         <li {...props}>
//                                             {option.title}
//                                         </li>
//                                     )}
//                                 />
//                             </Grid>
//                             <Grid item xs={4} sm={2} lg={2}>
//                                 <select
//                                     className={classes.selectform}
//                                     value={isVerified}
//                                     onChange={(e) => setIsVerified(e.target.value)}
//                                 >
//                                     <option value="">Select Lead type</option>
//                                     <option value="raw">Raw</option>
//                                     <option value="verified">Verified</option>
//                                 </select>
//                             </Grid>
//                             <Grid item xs={4} sm={2} lg={2}>
//                                 <select
//                                     className={classes.selectform}
//                                     value={moveType}
//                                     // onChange={(e) => setMoveType(e.target.value)}
//                                     onChange={(e) => {
//                                         const value = e.target.value;
//                                         setMoveType(value);
//                                         if (value !== "1") {
//                                             setSelectedLeadSource("");
//                                         }
//                                     }}
//                                 >
//                                     <option value="">Select Option</option>
//                                     <option value="1">Move To API</option>
//                                     <option value="2">Download and Supplier</option>
//                                 </select>
//                             </Grid>
//                             {showLeadSource && (
//                                 <Grid item xs={4} sm={2} lg={2}>
//                                     <select
//                                         className={classes.selectform}
//                                         value={selectedLeadSource}
//                                         onChange={(e) => setSelectedLeadSource(e.target.value)}
//                                     >
//                                         <option value="">Select Lead Source</option>
//                                         {sourceCodeOptions.map((option) => (
//                                             <option key={option.id} value={option.id}>
//                                                 {option.title}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </Grid>
//                             )}
//                             <Grid item xs={4} sm={2} lg={2}>
//                                 <div
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         height: "100%",
//                                         minHeight: "40px",
//                                     }}
//                                 >
//                                     <Checkbox
//                                         checked={changeBrand}
//                                         onChange={(e) => {
//                                             const checked = e.target.checked;
//                                             setChangeBrand(checked);
//                                             if (!checked) {
//                                                 setChangeBrandId(null);
//                                             }
//                                         }}
//                                         size="small"
//                                     />
//                                     <Typography variant="body2">Change Brand</Typography>
//                                 </div>
//                             </Grid>
//                             {changeBrand && (
//                                 <Grid item xs={4} sm={2} lg={2}>
//                                     <Autocomplete
//                                         classes={{
//                                             option: classes.autocompleteoption,
//                                         }}
//                                         options={brandOptions}
//                                         getOptionLabel={(option) => option.title || ""}
//                                         renderInput={(params) => (
//                                             <TextField
//                                                 {...params}
//                                                 placeholder="Change Brand To"
//                                                 variant="outlined"
//                                             />
//                                         )}
//                                         value={changeBrandId}
//                                         onChange={(event, newValue) => setChangeBrandId(newValue)}
//                                         isOptionEqualToValue={(option, value) => option.id === value.id}
//                                         getOptionSelected={(option, value) => option.id === value.id}
//                                         renderOption={(props, option) => (
//                                             <li {...props}>{option.title}</li>
//                                         )}
//                                     />
//                                 </Grid>
//                             )}


//                             <Grid item xs={4} sm={2} lg={4} >
//                                 <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}>
//                                     <Button
//                                         onClick={handleResetFields}
//                                         variant="outlined"
//                                         startIcon={<ClearIcon />}
//                                         style={{
//                                             backgroundColor: "#dc3545",
//                                             borderColor: "#dc3545",
//                                         }}
//                                         className={classes.buttonform}
//                                     >
//                                         Reset Fields
//                                     </Button>
//                                     <Button

//                                         onClick={handleSubmit}
//                                         type='submit'
//                                         style={{ marginRight: "10px" }}
//                                         className={classes.buttonform}
//                                         variant="outlined"
//                                         startIcon={
//                                             isLoading ? (
//                                                 <AutorenewIcon className={classes.rotateIcon} />
//                                             ) : isDataLoaded ? (
//                                                 <CheckCircleIcon />
//                                             ) : (
//                                                 <CloudDownloadIcon />
//                                             )
//                                         }>
//                                         {isLoading
//                                             ? "Loading..."
//                                             : isDataLoaded
//                                                 ? "Data Loaded"
//                                                 : "Get Data"}

//                                     </Button>
//                                     <Button
//                                         disabled={!isDataLoaded || isLoading}
//                                         onClick={handleMoveEnquiryClick}
//                                         style={{ backgroundColor: "#1976d2", borderColor: '#1976d2' }}
//                                         className={classes.buttonform}
//                                         variant="outlined"
//                                         startIcon={<AssignmentIndIcon />}
//                                     >
//                                         <span>{handleSelectedRowsCount()}</span>-Move Enquiry
//                                     </Button>
//                                 </div>
//                             </Grid>
//                         </Grid>
//                     </div>
//                 </div>
//             )}
//             <br />
//             <MuiThemeProvider theme={currentTheme}>
//                 {
//                     isLoading ? (
//                         <LinearProgress />
//                     ) : (
//                         ""
//                     )
//                 }
//                 <MUIDataTable
//                     title={
//                         isLoading ? (
//                             <Skeleton animation="wave" />
//                         ) : (
//                             <Typography className={classes.tabletittle} >
//                                 Not Connected
//                             </Typography>
//                         )
//                     }
//                     data={memoizedData}
//                     // columns={columns}
//                     columns={tableColumns}
//                     options={options}
//                 />
//             </MuiThemeProvider>
//             <Drawer anchor="right" open={openSidebar}
//                 PaperProps={{
//                     style: {
//                         width: "100%",
//                         maxWidth: 300,
//                         padding: "10px"
//                     }
//                 }}
//                 onClose={() => setOpenSidebar(false)}
//             >
//                 <form onSubmit={handleSubmit}>
//                     <Grid container spacing={1}>
//                         <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
//                             <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
//                         </Grid>
//                         <Grid item xs={4} sm={2} lg={12} >
//                             <br />
//                             <Typography className={classes.tabletittle} >
//                                 Filter
//                             </Typography>
//                         </Grid>
//                     </Grid>
//                     <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
//                         <div className={classes.root}>
//                             <Grid container spacing={1}>
//                                 <Grid item xs={12} sm={12} lg={12} >
//                                     <select
//                                         className={classes.inputform}
//                                         id="executiveSelect"
//                                         value={selectedExecutiveId}
//                                         onChange={handleExecutiveChange}
//                                     >
//                                         <option value="">Select Executive</option>
//                                         {executiveOptions.map(option => (
//                                             <option key={option.id} value={option.id}>
//                                                 {option.title}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </Grid>
//                                 <Grid item xs={12} sm={12} lg={12} >
//                                     <select
//                                         className={classes.inputform}
//                                         id="sourceSelect"
//                                         value={selectedSource}
//                                         onChange={handleSelectChange}
//                                     >
//                                         <option value="">Select Source</option>
//                                         {sources.map((source, index) => (
//                                             <option key={index} value={source}>{source}</option>
//                                         ))}
//                                     </select>
//                                 </Grid>
//                                 <Grid item xs={12} sm={12} lg={12} >
//                                     <Autocomplete
//                                         classes={{
//                                             option: classes.autocompleteoption,
//                                         }}
//                                         options={stateOptions}
//                                         getOptionLabel={(option) => option.title}
//                                         renderInput={(params) => (
//                                             <TextField {...params} placeholder='Select State' variant="outlined" />
//                                         )}
//                                         value={selectedState}
//                                         onChange={handleStateChange}
//                                         disableCloseOnSelect
//                                         isOptionEqualToValue={(option, value) => option.id === value.id}
//                                         getOptionSelected={(option, value) => option.id === value.id}
//                                         renderOption={(props, option, { selected }) => (
//                                             <li {...props}>
//                                                 {option.title}
//                                             </li>
//                                         )}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={12} sm={12} lg={12} >
//                                     <Autocomplete
//                                         classes={{
//                                             option: classes.autocompleteoption,
//                                         }}
//                                         options={brandOptions}
//                                         getOptionLabel={(option) => option.title}
//                                         renderInput={(params) => (
//                                             <TextField {...params} placeholder='Select brand' variant="outlined" />
//                                         )}
//                                         value={selectedBrand}
//                                         onChange={handleBrandChange}
//                                         disableCloseOnSelect
//                                         isOptionEqualToValue={(option, value) => option.id === value.id}
//                                         getOptionSelected={(option, value) => option.id === value.id}
//                                         renderOption={(props, option, { selected }) => (
//                                             <li {...props}>
//                                                 {option.title}
//                                             </li>
//                                         )}
//                                     />
//                                 </Grid>
//                                 <Grid item xs={4} sm={2} lg={12} >
//                                     <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
//                                 </Grid>

//                                 <Grid item xs={4} sm={2} lg={12}>
//                                     <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
//                                 </Grid>
//                             </Grid>
//                         </div>
//                     </div>
//                     <br />
//                     <Grid >
//                         <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
//                             <Button
//                                 type='submit'
//                                 style={{ marginRight: "10px" }}
//                                 className={classes.buttonform}
//                                 variant="outlined" startIcon={<ApprovalIcon />}>
//                                 Apply
//                             </Button>
//                             <Button
//                                 type="button" onClick={clearForm}
//                                 style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
//                                 className={classes.buttonform}
//                                 variant="outlined" startIcon={<ClearIcon />}>
//                                 Clear
//                             </Button>
//                         </Grid>
//                     </Grid>
//                     <br />
//                 </form>
//             </Drawer >

//             <Modal
//                 open={openConfirmModal}
//                 onClose={() => setOpenConfirmModal(false)}
//             >
//                 <Box
//                     sx={{
//                         position: "absolute",
//                         top: "50%",
//                         left: "50%",
//                         transform: "translate(-50%, -50%)",
//                         bgcolor: "background.paper",
//                         p: 3,
//                         borderRadius: 2,
//                         minWidth: 450,
//                         textAlign: "center",
//                         boxShadow: 24,
//                     }}
//                 >
//                     <Typography
//                         variant="h6"
//                         gutterBottom
//                         style={{
//                             fontWeight: 600,
//                             color: "#1976d2"
//                         }}
//                     >
//                         Move To Enquiry Confirmation
//                     </Typography>
//                     <Typography
//                         variant="body1"
//                         style={{
//                             marginBottom: "20px"
//                         }}
//                     >
//                         Are you sure you want to move
//                         <b> {selectedRows.length} </b>
//                         selected enquiry records?
//                     </Typography>

//                     <div
//                         style={{
//                             display: "flex",
//                             justifyContent: "center",
//                             gap: "10px",
//                             flexWrap: "wrap"
//                         }}
//                     >
//                         <Button
//                             variant="contained"
//                             color="primary"
//                             onClick={handleConfirmSubmit}
//                             disabled={isLoading}
//                         >
//                             {isLoading ? "Processing..." : "Yes, Move Enquiry"}
//                         </Button>

//                         <Button
//                             variant="contained"
//                             style={{
//                                 backgroundColor: "#28a745",
//                                 color: "#fff"
//                             }}
//                             onClick={() => {
//                                 exportSelectedRowsToCSV();
//                                 setOpenConfirmModal(false);
//                             }}
//                         >
//                             Export Selected CSV
//                         </Button>

//                         <Button
//                             variant="outlined"
//                             color="secondary"
//                             onClick={() => setOpenConfirmModal(false)}
//                         >
//                             Cancel
//                         </Button>
//                     </div>
//                 </Box>
//             </Modal>

//         </>
//     );
// };
// export default NotConnected;


// const inputStyle = {
//     width: "100%",
//     minWidth: "150px",
//     boxSizing: "border-box",
//     padding: "8px",
//     border: "1px solid #ccc",
//     borderRadius: "4px",
// };



const NotConnected = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const [selectedExecutiveId, setSelectedExecutiveId] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [sources, setSources] = useState([]);
    const [selectedSource, setSelectedSource] = useState();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    // @@@@@@@@@@@@@@@@@@@@@@@@@ start 
    const [productBrand, setProductBrand] = useState([]);
    const [states, setStates] = useState([]);
    const [selectedExecutive, setSelectedExecutive] = useState(null);
    const [excutiveassign, setExcutiveAssign] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [editedRows, setEditedRows] = useState({});
    const [doubleClickedRow, setDoubleClickedRow] = useState(null);
    const [message, setMessage] = useState('');
    const [showMoveEnquiry, setShowMoveEnquiry] = useState(false);
    const [moveType, setMoveType] = useState("");
    const [isVerified, setIsVerified] = useState("");
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [campaignOptions, setCampaignOptions] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState([]);
    const [selectedModel, setSelectedModel] = useState(null);
    const [modelOptions, setModelOptions] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [projectOptions, setProjectOptions] = useState([]);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [selectedLeadSource, setSelectedLeadSource] = useState("");
    const [changeBrand, setChangeBrand] = useState(false);
    const [changeBrandId, setChangeBrandId] = useState(null);
    const [isLoan, setIsLoan] = useState(false);
    const [loanType, setLoanType] = useState("loan");
    const [clientName, setClientName] = useState("tyger");


    const showLeadSource =
        moveType === "1" &&
        [12, 16, 17].includes(Number(selectedBrand?.id));
    const sourceCodeOptions = [
        { id: "CC0117P", title: "KG Paid" },
        { id: "CC0117O", title: "KG Organic" },
        { id: "CC0117B", title: "KG Branding" },
    ];

    const exportSelectedRowsToCSV = () => {
        const selectedData = selectedRows.map((index) => {
            const row = {
                ...data[index],
                ...(editedRows[index] || {}),
            };
            return {
                "Date": row?.created_at ?? "",
                "Brand Name": row?.brand_name ?? "",
                "Model Name": row.tractor_model_name || selectedModel?.title || "",
                "First Name": row?.first_name ?? "",
                "Last Name": row?.last_name ?? "",
                "Mobile": row?.mobile ?? "",
                "Email": row?.email ?? "",
                "State": row?.state_name ?? "",
                "City": row?.city_name ?? "",
                "Taluka": row?.taluka ?? "",
                "Enquiry Type": row?.enquiry_name ?? "",
                "Enquiry Source": row?.enquiry_from ?? "",
                "Executive": row?.executive ?? "",
            };
        });
        if (selectedData.length === 0) {
            setSnackbarMessage("Please select at least one row");
            setSnackbarOpen(true);
            return;
        }
        const headers = Object.keys(selectedData[0]);
        const csvRows = [
            headers.join(","),
            ...selectedData.map(row =>
                headers.map(header => `"${row[header] ?? ""}"`).join(",")
            )
        ];
        const csvContent = csvRows.join("\n");
        const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
            "download",
            `SocialCampaigns_${new Date().toISOString().split("T")[0]}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleCellChange = (rowIndex, field, value) => {
        setEditedRows((prev) => ({
            ...prev,
            [rowIndex]: {
                ...data[rowIndex],
                ...(prev[rowIndex] || {}),
                [field]: value,
            },
        }));
    };
    const handleConfirmSubmit = async () => {
        if (!validateMoveEnquiryForm()) {
            return;
        }
        await handleMoveEnquirySubmit();
    };
    useEffect(() => {
        fetchCampaignList();
    }, []);
    const fetchCampaignList = async () => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": token,
                }
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/campaign-list`,
                {},
                config
            );
            const campaigns =
                response?.data?.data?.assigned_list?.map(item => ({
                    id: item.id,
                    title: item.campaign_id
                })) || [];
            setCampaignOptions(campaigns);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchProjectList();
    }, []);
    const fetchProjectList = async () => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": token,
                },
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/assign-project-brand-list`,
                {},
                config
            );
            const projects =
                response?.data?.data?.data?.map(item => ({
                    id: item.id,
                    title: item.project_name,
                    brand_id: item.brand_id,
                    brand_name: item.brand_name,
                })) || [];
            setProjectOptions(projects);
        } catch (error) {
            console.error(error);
        }
    };
    const handleBrandChange = async (event, newValue) => {
        setSelectedBrand(newValue);
        setSelectedModel(null);
        setModelOptions([]);
        if (!newValue?.id) return;
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": token,
                },
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/brand-model-list`,
                {
                    brand_id: newValue.id
                },
                config
            );
            const models =
                response?.data?.data?.map(item => ({
                    id: item.tractor_model_id,
                    title: item.tractor_model_name
                })) || [];

            setModelOptions(models);
        } catch (error) {
            console.error(error);
        }
    };
    const handleProjectChange = (event, newValue) => {
        setSelectedProject(newValue);
    };
    const validateMoveEnquiryForm = () => {
        if (!isDataLoaded) {
            setSnackbarSeverity("error");
            setSnackbarMessage("Please click 'Get Data' before moving enquiries.");
            setSnackbarOpen(true);
            return false;
        }
        if (data.length === 0) {
            setSnackbarSeverity("error");
            setSnackbarMessage("No data found. Please click Get Data.");
            setSnackbarOpen(true);
            return false;
        }
        if (!selectedBrand?.id) {
            setSnackbarSeverity("error");
            setSnackbarMessage("Brand is required");
            setSnackbarOpen(true);
            return false;
        }
        if (!isVerified) {
            setSnackbarSeverity("error");
            setSnackbarMessage("Lead Type is required");
            setSnackbarOpen(true);
            return false;
        }
        if (!moveType) {
            setSnackbarSeverity("error");
            setSnackbarMessage("Move Type is required");
            setSnackbarOpen(true);
            return false;
        }
        if (moveType === "1" && isLoan && (!loanType || !clientName)) {
            setSnackbarSeverity("error");
            setSnackbarMessage("Please select Loan Type and Client Name");
            setSnackbarOpen(true);
            return false;
        }
        if (selectedRows.length === 0) {
            setSnackbarSeverity("error");
            setSnackbarMessage("Please select at least one enquiry");
            setSnackbarOpen(true);
            return false;
        }
        return true;
    };
    const handleMoveEnquiryClick = () => {
        if (!validateMoveEnquiryForm()) {
            return;
        }
        setOpenConfirmModal(true);
    };
    const handleResetFields = () => {
        setSnackbarSeverity("success");
        setSelectedBrand(null);
        setSelectedModel(null);
        setSelectedState(null);
        setSelectedProject(null);
        setChangeBrand(false);
        setChangeBrandId(null);
        setIsVerified("");
        setMoveType("");
        setFromDate(currentDate.toISOString().split("T")[0]);
        setToDate(currentDate.toISOString().split("T")[0]);
        setSelectedRows([]);
        setSelectedExecutive("");
        setSelectedLeadSource("");
        setIsLoan(false);
        setLoanType("loan");
        setClientName("tyger");
        setSnackbarOpen(true);
        setOpenConfirmModal(false);
        setSnackbarMessage("Form fields reset successfully");
    };

    // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@ end

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/webApi/sources`);
                const data = response.data.data;
                setSources(data.map(item => item.enquiry_from));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleSelectChange = (event) => {
        setSelectedSource(event.target.value);
    };

    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);

    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));
                setStateOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatastate();
    }, []);

    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const mappedData = response.data.data.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                setExecutiveOptions(mappedData);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };
        fetchDatalist();
    }, []);

    const handleExecutiveChange = (event) => {
        const selectedId = event.target.value;
        setSelectedExecutiveId(selectedId);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };

    // const handleBrandChange = (event, newValue) => {
    //     setSelectedBrand(newValue);
    // };

    const fetchData = async (from, to, pageNumber, searchQuery,) => {
        setIsLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `${token}`,
                    'adminId': `${adminId}`,
                    'userLevel': `${userLevel}`,
                },
                timeout: Infinity,
            };

            const requestData = {
                start_date: fromDate,
                end_date: toDate,
                pagination: perPage,
                page: page + 1,
                search: search,
                product_brand: selectedBrand,
                enquiry_source: enquirySource,
                states: selectedState,
                executive: selectedExecutiveId,
                user_level: userLevel,
                admin_id: adminId,
                enquiry_source: selectedSource ? [{ from: selectedSource }] : null,
            };
            if (userLevel === 'executive') {
                requestData.executive = adminId;
            } else {
                requestData.executive = selectedExecutiveId;
            }
            const response = await axios.post(`${API_BASE_URL}/api/admin/v2/not-connected-enquiry`, requestData, config);

            const mappedData = response.data.data.data.map(item => {
                const formattedDate = new Date(item.updated_at).toLocaleString('en-IN', {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour12: true,
                });
                const date = item.date ? new Date(item.date).toLocaleString('en-IN', {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour12: true,
                }) : "";
                const first_name = item.user.first_name;
                const last_name = item.user.last_name;
                const fullName = `${item.user.first_name} ${item.user.last_name}`;
                const tractorname = item.tractor_table.tractor_model ? item.tractor_table.tractor_model.tractor_model_name : '';
                const brandname = item.tractor_table.brand ? item.tractor_table.brand.brand_name : '';
                const stateName = item.user.state ? item.user.state.state_name : '';
                const cityName = item.user.city ? item.user.city.city_name : '';
                const taluka = item.user.taluka ? item.user.taluka.name : '';
                const executive = item.executive ? item.executive.username : '';
                const admin_id = item.executive ? item.executive.admin_id : '';
                const call_status = item.crm_call_status ? item.crm_call_status.call_status : '';
                const pincode = item.user.user_details ? item.user.user_details.pincode : '';
                const village = item.user.user_details ? item.user.user_details.village : '';
                const land = item.user.user_details ? item.user.user_details.land : '';
                const exchangetractor = item.exchanged_tractor ? item.exchanged_tractor.tractor_name : '';
                const loan_types = item.enq_details ? item.enq_details.map(detail => detail.loan_type) : [];

                const loanTypesObject = {};
                loan_types.forEach((type, index) => {
                    loanTypesObject[`loan_type_${index + 1}`] = type;
                });
                const lastValue = loanTypesObject[`loan_type_${Object.keys(loanTypesObject).length}`];
                const Purchasedate = item.enq_details ? item.enq_details.map(detail => {
                    const options = {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour12: true,
                    };
                    return new Date(detail.date).toLocaleString('en-IN', options);
                }) : [];
                return {
                    id: item.id,
                    enquiry_name: item.enquiry_name,
                    fullName: fullName,
                    mobile: item.user.mobile,
                    email: item.user.email,
                    created_at: formattedDate,
                    tractor_model_name: tractorname,
                    brand_name: brandname,
                    state_name: stateName,
                    city_name: cityName,
                    taluka: taluka,
                    executive: executive,
                    admin_id: admin_id,
                    enquiry_from: item.enquiry_from,
                    is_dublicate: item.is_dublicate,
                    call_status: call_status,
                    pincode: pincode,
                    village: village,
                    land: land,
                    loan_type: lastValue,
                    Purchasedate: date,
                    exchanged: item.exchanged,
                    tractor_name: exchangetractor,
                    first_name: first_name,
                    last_name: last_name,
                    enq_details_count: item.enq_details_count,
                };
            });
            setData(mappedData);
            setTotalCount(response.data.data.total);
            setSnackbarMessage(response.data.message);
            setSnackbarOpen(true);
            setIsLoading(false);
            setIsDataLoaded(true);

        } catch (error) {
            console.error("Error fetching data:", error);
            if (axios.isCancel(error)) {
                console.error("Request canceled:", error.message);
            } else {
                if (error.code === 'ECONNABORTED') {
                    setError('The request timed out. Please try again.');
                } else if (error.response) {
                    console.error("Server Error Details:", error.response.data);
                    setError(`Error: ${error.response.status} - ${error.response.statusText}`);
                } else {
                    setError('An error occurred while fetching data.');
                }
            }

        } finally {
            setIsLoading(false);
        }
    };
    const source = axios.CancelToken.source();
    const sourceRef = useRef(null);
    useEffect(() => {
        sourceRef.current = axios.CancelToken.source();
        fetchData(
            perPage,
            page,
            search,
            totalCount,
            selectedExecutiveId,
            selectedBrand,
            selectedState,
            enquirySource,
            sourceRef.current
        );
        return () => {
            sourceRef.current.cancel('Request canceled by cleanup');
        };
    }, [perPage, page,], 2000);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };

    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };

    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };

    const handleNext = () => {
        setPage(page + 1);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        fetchData(perPage, page, search, totalCount, selectedExecutiveId, selectedBrand, selectedState, enquirySource);
    };

    const clearForm = () => {
        window.location.reload();
        setSearch('');
    };
    const handleSelectAllCheck = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(Array.from({ length: data.length }, (_, i) => i));
        }
    };
    const handleRowSelect = (rowIndex) => {
        if (selectedRows.includes(rowIndex)) {
            setSelectedRows(selectedRows.filter((row) => row !== rowIndex));
        } else {
            setSelectedRows([...selectedRows, rowIndex]);
        }
    };

    const handleSelectedRowsCount = () => {
        return selectedRows.length;
    };


    const columns = [
        {
            name: 'id',
            label: (
                <input
                    type="checkbox"
                    checked={selectedRows.length === data.length && data.length !== 0}
                    onChange={handleSelectAllCheck}
                />
            ),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => (
                    <input
                        type="checkbox"
                        checked={selectedRows.includes(tableMeta.rowIndex)}
                        onChange={() => handleRowSelect(tableMeta.rowIndex)}
                    />
                ),
            },
        },
        {
            name: 'id',
            label: 'S/N',
            options: {
                filter: true,
                setCellProps: () => ({
                    align: "center",
                }),
            },
        },
        {
            name: 'created_at', options: {
                filter: true,
                setCellProps: () => ({
                    align: "left",
                })
            },
            label: "Date",
        },
        {
            name: "enquiry_name",
            label: "Type",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <button
                        className={classes.typestrip}
                        style={{
                            backgroundColor: getColor(value),
                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "brand_name",
            label: "Brand",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <button
                        className={classes.brandstrip}
                        style={{
                            backgroundColor: getColor(value),
                            color: getColorfont(value),
                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "tractor_model_name",
            label: "Model ",
        },
        {
            name: "fullName",
            label: "User ",
        },
        {
            name: "mobile",
            label: "Mobile  ",
        },
        {
            name: "state_name",
            label: "State  ",
        },
        {
            name: "city_name",
            label: "City  ",
        },
        {
            name: "taluka",
            label: "Taluka  ",
        },
        {
            name: "pincode",
            label: "Pinecode  ",
        },
        {
            name: "village",
            label: "Village  ",
        },
        {
            name: "land",
            label: "Land  ",
        },


        {
            name: "enquiry_from",
            label: "Source",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <button
                        className={classes.typestrip}
                        style={{
                            backgroundColor: getColor(value),
                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "name",
            label: "Status",
        },
        {
            name: "executive",
            label: "Executive ",
        },
        {
            name: "enq_details_count",
            label: "Followup",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <button
                        className={classes.typestrip}
                        style={{
                            backgroundColor: getColor(value),
                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "Purchasedate",
            label: "Followp Date",
        },
        {
            name: "actions",
            label: "Actions",
            options: {
                filter: false,
                setCellProps: () => ({
                    align: "right",
                }),
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;
                    const rowData = data[rowIndex];
                    return (
                        <>
                            <div style={{ display: "flex", margin: "auto", padding: "auto", textAlign: "center" }} >
                                <Link to={`/app/NotConnectedView/${tableMeta.rowData[0]}`} target="_blank">
                                    <VisibilityIcon className={classes.tableiconedit} />
                                </Link>
                            </div>
                        </>
                    );
                },
            },
        },
    ];

    const columnsEdittable = [
        {
            name: 'id',
            label: (
                <input
                    type="checkbox"
                    checked={selectedRows.length === data.length && data.length !== 0}
                    onChange={handleSelectAllCheck}
                />
            ),
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => (
                    <input
                        type="checkbox"
                        checked={selectedRows.includes(tableMeta.rowIndex)}
                        onChange={() => handleRowSelect(tableMeta.rowIndex)}
                    />
                ),
            },
        },
        {
            name: 'id', options: {
                filter: false,
                setCellProps: () => ({
                    align: "left",
                })
            },
            label: "S/N",
        },
        {
            name: 'created_at',
            options: {
                filter: false,
                setCellProps: () => ({
                    align: "left",
                })
            },
            label: "Date",
        },
        {
            name: "enquiry_name",
            label: "Type",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <button
                        className={classes.typestrip}
                        style={{
                            backgroundColor: getColor(value),
                            width: "100%",

                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "brand_name",
            label: "Brand",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <button
                        className={classes.brandstrip}

                        style={{
                            backgroundColor: getColor(value),
                            color: getColorfont(value),
                            width: "100% !important",

                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "tractor_model_name",
            label: "Model ",
            options: {
                filter: false,
            }
        },
        {
            name: "first_name",
            label: "First Name",
            options: {
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;

                    return (
                        <input
                            style={inputStyle}
                            value={editedRows[rowIndex]?.first_name ?? value ?? ""}
                            onChange={(e) =>
                                handleCellChange(
                                    rowIndex,
                                    "first_name",
                                    e.target.value
                                )
                            }
                        />
                    );
                }
            }
        },
        {
            name: "last_name",
            label: "Last Name",
            options: {
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;

                    return (
                        <input
                            style={inputStyle}
                            value={editedRows[rowIndex]?.last_name ?? value ?? ""}
                            onChange={(e) =>
                                handleCellChange(
                                    rowIndex,
                                    "last_name",
                                    e.target.value
                                )
                            }
                        />
                    );
                }
            }
        },
        {
            name: "mobile",
            label: "Mobile",
            options: {
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;

                    return (
                        <input
                            type="text"
                            value={
                                editedRows[rowIndex]?.mobile ??
                                value ??
                                ""
                            }
                            onChange={(e) =>
                                handleCellChange(
                                    rowIndex,
                                    "mobile",
                                    e.target.value
                                )
                            }
                            style={inputStyle}
                        />
                    );
                }
            }
        },
        {
            name: "email",
            label: "Email ",
            options: {
                filter: false,
            }
        },
        {
            name: "state_name",
            label: "State",
            options: {
                filter: false,
            }
        },
        {
            name: "city_name",
            label: "City ",
            options: {
                filter: false,
            }
        },
        {
            name: "taluka",
            label: "Taluka ",
            options: {
                filter: false,
            }
        },
        {
            name: "enquiry_from",
            label: "From ",
            options: {
                filter: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <button
                        className={classes.typestrip}
                        style={{
                            backgroundColor: getColor(value),
                            width: "100%",

                        }}
                    >
                        {value}
                    </button>
                ),
            },
        },
        {
            name: "executive",
            label: "Executive ",
            options: {
                filter: false,
            }

        },
        {
            name: "is_dublicate",
            label: "Dublicate ",
            options: {
                filter: false,
            }
        },
        {
            name: "actions",
            label: "Actions",
            options: {
                filter: false,
                setCellProps: () => ({
                    align: "right",
                }),
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;
                    const rowData = data[rowIndex];
                    return (
                        <>
                            <Link to={`/app/UpdateFollowUpEnquiry/${rowData.id}/crm`} target="_blank">
                                <Button
                                    style={{ width: "20px", fontSize: "10px" }}
                                    className={classes.buttonform}
                                    variant="outlined" startIcon={<EditIcon style={{ fontSize: "12px" }} />}>
                                    Update
                                </Button>
                            </Link>
                        </>
                    );
                },
            },
        },
    ];

    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === 'F') {
                setOpenSidebar(true);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);
    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const options = {
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },

        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),

    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleMoveEnquirySubmit = async () => {
        if (!validateMoveEnquiryForm()) return;
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminid": `${adminId}`,
                    "userlevel": `${userLevel}`,
                }
            };
            const payload = {
                move_type: Number(moveType),
                ...(showLeadSource && { lead_source: selectedLeadSource }),
                ...(Number(moveType) === 1 && {
                    is_loan: isLoan ? 1 : 0,
                    ...(isLoan && { loan_type: loanType, client_name: clientName })
                }),
                brand_id: selectedBrand?.id || null,
                change_brand: changeBrand ? 1 : 0,
                change_brand_id:
                    changeBrand && changeBrandId ? Number(changeBrandId.id) : null,
                state_id: selectedState?.id || null,
                project_id: selectedProject?.id || null,
                is_verified: isVerified,
                model: selectedModel?.title || "",
                id_selected: selectedRows.map(index => {
                    const row = {
                        ...data[index],
                        ...(editedRows[index] || {}),
                    };
                    return {
                        id: row.id,
                        first_name: row.first_name || "",
                        last_name: row.last_name || "",
                        email: row.email || "",
                        mobile: row.mobile || "",
                        state: row.state_id || "",
                        city: row.city_id || "",
                        taluka: row.taluka_id || "",
                        // modelName: row.tractor_model_name || ""
                    };
                })
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/move-to-allenquiries`,
                payload,
                config
            );
            if (
                response?.data?.status_code === 200 &&
                !response?.data?.error
            ) {
                setSnackbarSeverity("success");
                setSnackbarMessage(response.data.message);
                setSnackbarOpen(true);
                setSelectedRows([]);
                fetchData();
                setOpenConfirmModal(false);
            }

        } catch (error) {
            setSnackbarSeverity("error");
            setSnackbarMessage(
                error?.response?.data?.message ||
                "Something went wrong"
            );
            setSnackbarOpen(true);
        }
    };

    const tableColumns = useMemo(() => {
        return ["1", "2",].includes(moveType)
            ? columnsEdittable
            : columns;
    }, [moveType, editedRows, columnsEdittable, columns]);

    useEffect(() => {
        setSelectedRows([]);
        setEditedRows({});
        setIsDataLoaded(false);
    }, [
        selectedCampaign,
        selectedBrand,
        selectedModel,
        selectedState,
        selectedProject,
        isVerified,
        moveType,
        fromDate,
        toDate,
        page,
        perPage
    ]);

    return (
        <>
            <div>
                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }} open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>
            <div style={{ display: "flex" }}>
                <Grid item xs={10} sm={6} lg={10} >
                    <Link to="/app/allEnquiries" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheaderfirst)}> All Enquiries </Link>

                    <Link to="/app/TodayPending" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)} >Today's Pending </Link>
                    <Link to="/app/Interested" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)} >Interested</Link>
                    <Link to="/app/AlreadyPurchased" className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)} >Already Purchased</Link>
                    <Button
                        style={{ marginLeft: "20px", }}
                        className={classes.buttonred}
                        variant="outlined" startIcon={<LightModeIcon />}>
                        Not Connected
                    </Button>

                    <Link className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)}>Update / FollowUp</Link>
                    {userLevelAccess === "super" && (
                        <Link className={classNames(classes.breadcrumbslinkHightlight, classes.bridheader)}
                            onClick={() => setShowMoveEnquiry(!showMoveEnquiry)}
                            style={{
                                cursor: "pointer",
                                color: showMoveEnquiry ? "green" : "red",
                                fontWeight: "bold"
                            }}
                        >
                            Move to Enquiry ({showMoveEnquiry ? "ON" : "OFF"})
                        </Link>
                    )}

                </Grid>
                <Grid item xs={4} sm={2} lg={2} style={{ textAlign: "right", margin: "auto", padding: "auto" }}>
                    <Grid container>
                        <Grid item xs={10} sm={10} lg={10}>
                            <SearchUserform />
                        </Grid>
                        <Grid item xs={2} sm={2} lg={2} style={{ paddingTop: "8px" }}>
                            <AddUpdateUser />
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <Box sx={{ width: '100%' }}>
                <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                </Typography>
                <hr className={classes.horizontalline} />
            </Box>
            {showMoveEnquiry && (

                <div className={classes.root}>
                    <div className={classes.root}  >
                        <Grid container spacing={1}>
                            <Grid item xs={4} sm={2} lg={2} >
                                <input
                                    type="date"
                                    name="fromDate"
                                    value={fromDate}
                                    onChange={handleDateChange}
                                    className={classes.inputform}
                                />
                            </Grid>

                            <Grid item xs={4} sm={2} lg={2}>
                                <input
                                    className={classes.inputform}
                                    type="date"
                                    name="toDate"
                                    value={toDate}
                                    onChange={handleDateChange}
                                />
                            </Grid>

                            <Grid item xs={4} sm={2} lg={2} >
                                <Autocomplete
                                    classes={{
                                        option: classes.autocompleteoption,
                                    }}
                                    options={brandOptions}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder='Select brand' variant="outlined" />
                                    )}
                                    value={selectedBrand}
                                    onChange={handleBrandChange}
                                    disableCloseOnSelect
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            {option.title}
                                        </li>
                                    )}
                                />
                            </Grid>

                            <Grid item xs={4} sm={2} lg={2}>
                                <Autocomplete
                                    classes={{
                                        option: classes.autocompleteoption,
                                    }}
                                    options={modelOptions}
                                    getOptionLabel={(option) => option.title || ""}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Model"
                                            variant="outlined"
                                        />
                                    )}
                                    value={selectedModel}
                                    onChange={(event, newValue) => setSelectedModel(newValue)}
                                    disableCloseOnSelect
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.title}
                                        </li>
                                    )}
                                />
                            </Grid>

                            <Grid item xs={4} sm={2} lg={2} >
                                <Autocomplete
                                    classes={{
                                        option: classes.autocompleteoption,
                                    }}
                                    options={stateOptions}
                                    getOptionLabel={(option) => option.title}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder='Select State' variant="outlined" />
                                    )}
                                    value={selectedState}
                                    onChange={handleStateChange}
                                    disableCloseOnSelect
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            {option.title}
                                        </li>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={4} sm={2} lg={2}>
                                <Autocomplete
                                    classes={{
                                        option: classes.autocompleteoption,
                                    }}
                                    options={projectOptions}
                                    getOptionLabel={(option) => option.title || ""}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Project Name"
                                            variant="outlined"
                                        />
                                    )}
                                    value={selectedProject}
                                    onChange={handleProjectChange}
                                    disableCloseOnSelect
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.title}
                                        </li>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={4} sm={2} lg={2}>
                                <select
                                    className={classes.selectform}
                                    value={isVerified}
                                    onChange={(e) => setIsVerified(e.target.value)}
                                >
                                    <option value="">Select Lead type</option>
                                    <option value="raw">Raw</option>
                                    <option value="verified">Verified</option>
                                </select>
                            </Grid>
                            <Grid item xs={4} sm={2} lg={2}>
                                <select
                                    className={classes.selectform}
                                    value={moveType}
                                    // onChange={(e) => setMoveType(e.target.value)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setMoveType(value);
                                        if (value !== "1") {
                                            setSelectedLeadSource("");
                                            setIsLoan(false);
                                            setLoanType("loan");
                                            setClientName("tyger");
                                        }
                                    }}
                                >
                                    <option value="">Select Option</option>
                                    <option value="1">Move To API</option>
                                    <option value="2">Download and Supplier</option>
                                </select>
                            </Grid>
                            {showLeadSource && (
                                <Grid item xs={4} sm={2} lg={2}>
                                    <select
                                        className={classes.selectform}
                                        value={selectedLeadSource}
                                        onChange={(e) => setSelectedLeadSource(e.target.value)}
                                    >
                                        <option value="">Select Lead Source</option>
                                        {sourceCodeOptions.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.title}
                                            </option>
                                        ))}
                                    </select>
                                </Grid>
                            )}
                            <Grid item xs={4} sm={2} lg={2}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        minHeight: "40px",
                                    }}
                                >
                                    <Checkbox
                                        checked={changeBrand}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setChangeBrand(checked);
                                            if (!checked) {
                                                setChangeBrandId(null);
                                            }
                                        }}
                                        size="small"
                                    />
                                    <Typography variant="body2">Change Brand</Typography>
                                </div>
                            </Grid>
                            {moveType === "1" && (
                                <Grid item xs={4} sm={2} lg={2}>
                                    <div style={{ display: "flex", alignItems: "center", height: "100%", minHeight: "40px" }}>
                                        <Checkbox checked={isLoan} onChange={(e) => {
                                            setIsLoan(e.target.checked);
                                            if (!e.target.checked) {
                                                setLoanType("loan");
                                                setClientName("tyger");
                                            }
                                        }} size="small" />
                                        <Typography variant="body2">Is Loan</Typography>
                                    </div>
                                </Grid>
                            )}
                            {moveType === "1" && isLoan && (
                                <>
                                    <Grid item xs={4} sm={2} lg={2}>
                                        <select className={classes.selectform} value={loanType} onChange={(e) => setLoanType(e.target.value)}>
                                            <option value="loan">Loan</option>
                                            <option value="finance">Finance</option>
                                        </select>
                                    </Grid>
                                    <Grid item xs={4} sm={2} lg={2}>
                                        <select className={classes.selectform} value={clientName} onChange={(e) => setClientName(e.target.value)}>
                                            <option value="tyger">Tyger</option>
                                        </select>
                                    </Grid>
                                </>
                            )}
                            {changeBrand && (
                                <Grid item xs={4} sm={2} lg={2}>
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title || ""}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Change Brand To"
                                                variant="outlined"
                                            />
                                        )}
                                        value={changeBrandId}
                                        onChange={(event, newValue) => setChangeBrandId(newValue)}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option) => (
                                            <li {...props}>{option.title}</li>
                                        )}
                                    />
                                </Grid>
                            )}


                            <Grid item xs={4} sm={2} lg={4} >
                                <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px" }}>
                                    <Button
                                        onClick={handleResetFields}
                                        variant="outlined"
                                        startIcon={<ClearIcon />}
                                        style={{
                                            backgroundColor: "#dc3545",
                                            borderColor: "#dc3545",
                                        }}
                                        className={classes.buttonform}
                                    >
                                        Reset Fields
                                    </Button>
                                    <Button

                                        onClick={handleSubmit}
                                        type='submit'
                                        style={{ marginRight: "10px" }}
                                        className={classes.buttonform}
                                        variant="outlined"
                                        startIcon={
                                            isLoading ? (
                                                <AutorenewIcon className={classes.rotateIcon} />
                                            ) : isDataLoaded ? (
                                                <CheckCircleIcon />
                                            ) : (
                                                <CloudDownloadIcon />
                                            )
                                        }>
                                        {isLoading
                                            ? "Loading..."
                                            : isDataLoaded
                                                ? "Data Loaded"
                                                : "Get Data"}

                                    </Button>
                                    <Button
                                        disabled={!isDataLoaded || isLoading}
                                        onClick={handleMoveEnquiryClick}
                                        style={{ backgroundColor: "#1976d2", borderColor: '#1976d2' }}
                                        className={classes.buttonform}
                                        variant="outlined"
                                        startIcon={<AssignmentIndIcon />}
                                    >
                                        <span>{handleSelectedRowsCount()}</span>-Move Enquiry
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            )}
            <br />
            <MuiThemeProvider theme={currentTheme}>
                {
                    isLoading ? (
                        <LinearProgress />
                    ) : (
                        ""
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />
                        ) : (
                            <Typography className={classes.tabletittle} >
                                Not Connected
                            </Typography>
                        )
                    }
                    data={memoizedData}
                    // columns={columns}
                    columns={tableColumns}
                    options={options}
                />
            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <select
                                        className={classes.inputform}
                                        id="executiveSelect"
                                        value={selectedExecutiveId}
                                        onChange={handleExecutiveChange}
                                    >
                                        <option value="">Select Executive</option>
                                        {executiveOptions.map(option => (
                                            <option key={option.id} value={option.id}>
                                                {option.title}
                                            </option>
                                        ))}
                                    </select>
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <select
                                        className={classes.inputform}
                                        id="sourceSelect"
                                        value={selectedSource}
                                        onChange={handleSelectChange}
                                    >
                                        <option value="">Select Source</option>
                                        {sources.map((source, index) => (
                                            <option key={index} value={source}>{source}</option>
                                        ))}
                                    </select>
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={stateOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select State' variant="outlined" />
                                        )}
                                        value={selectedState}
                                        onChange={handleStateChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select brand' variant="outlined" />
                                        )}
                                        value={selectedBrand}
                                        onChange={handleBrandChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
                                </Grid>

                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >

            <Modal
                open={openConfirmModal}
                onClose={() => setOpenConfirmModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        p: 3,
                        borderRadius: 2,
                        minWidth: 450,
                        textAlign: "center",
                        boxShadow: 24,
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        style={{
                            fontWeight: 600,
                            color: "#1976d2"
                        }}
                    >
                        Move To Enquiry Confirmation
                    </Typography>
                    <Typography
                        variant="body1"
                        style={{
                            marginBottom: "20px"
                        }}
                    >
                        Are you sure you want to move
                        <b> {selectedRows.length} </b>
                        selected enquiry records?
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "10px",
                            flexWrap: "wrap"
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleConfirmSubmit}
                            disabled={isLoading}
                        >
                            {isLoading ? "Processing..." : "Yes, Move Enquiry"}
                        </Button>

                        <Button
                            variant="contained"
                            style={{
                                backgroundColor: "#28a745",
                                color: "#fff"
                            }}
                            onClick={() => {
                                exportSelectedRowsToCSV();
                                setOpenConfirmModal(false);
                            }}
                        >
                            Export Selected CSV
                        </Button>

                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => setOpenConfirmModal(false)}
                        >
                            Cancel
                        </Button>
                    </div>
                </Box>
            </Modal>

        </>
    );
};
export default NotConnected;

const inputStyle = {
    width: "100%",
    minWidth: "150px",
    boxSizing: "border-box",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
};